import { map, merge } from 'lodash';

// export const getFormulaName = (str) => upperFirst(camelCase(str));
// export const arrayIdNameToObject = (arr) => arr.reduce((prev, { _id, name }) => ({ ...prev, [_id]: name }), {});

export const inputFieldsToVariables = (inputFields) => merge(...map(inputFields, (inputField) => map(inputField.options, (option) => ({ [option._id]: option.value }))).flat());
export const variablesFromCategory = ({ cartCategory, inputFields }) => {
  const a = cartCategory.inputFields?.reduce((prev, { _id, value }) => ({ ...prev, [_id]: value }), {});
  const b = inputFieldsToVariables(inputFields);
  return { ...a, ...b };
};

export const variablesFromCart = ({ cart, inputFields }) => {
  return merge(...cart.map((cartCategory) => variablesFromCategory({ cartCategory, inputFields })));
};

export const formatCurrency = (() => {
  const formatter = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  return (number = 0) => {
    const parts = formatter.formatToParts(number);
    const strArray = [];
    // filter out the decimal part
    parts.forEach((part) => {
      // if (['decimal', 'fraction'].includes(part.type)) return;
      strArray.push(part.value);
    });
    return strArray.join('');
  };
})();
